import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment';
import { getPosts } from '../../../../core/actions/postGet';
import { deletePost } from '../../../../core/actions/uploadPost';
import { Table, Icon, Button, Tag, Row, Popconfirm, notification } from 'antd';
import { Link  } from 'react-router-dom'


const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};

export class PostManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      posts: [],
      columns: [
        // {
        //   title: 'USER ID',
        //   dataIndex: 'id',
        //   key: 'id'
        // },
        {
          title: 'TITLE',
          dataIndex: 'title',
          key: 'title',
        }, 
        {
          title: 'READTIME',
          dataIndex: 'readTime',
          key: 'readTime',
          render: (text, record) => (
            <span>
              <Tag color="blue" className="tag">{record.readTime} mins</Tag>
            </span>
          )
        }, 
        {
          title: 'AUTHOR',
          dataIndex: 'author',
          key: 'author'
        },
        {
          title: 'DATE CREATED',
          dataIndex: 'created',
          key: 'created',
          render: (text, record) => (
            <span>
              {moment(record.created).format("MMMM Do YYYY")}
            </span>
          )
        },
        {
          title: 'ACTION',
          key: 'action',
          render: (text, record) => (
            <span>
              <Button type="primary" className="edit-btn" size="small"><Link to={`/editpost/${record.slug}`}> Edit <Icon type="edit" /></Link></Button>
              <Popconfirm
                title="Are you sure delete this task?"
                onConfirm={() => this.confirmDelte(record.id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" size="small"> Delete <Icon type="delete" /></Button>
              </Popconfirm>
            </span>
          )
        }
      ]
    }
    this.confirmDelte = this.confirmDelte.bind(this)
    this.restructurePosts = this.restructurePosts.bind(this)
  }

  componentDidMount() {
    // console.log(this.state)
    const { posts } = this.state;
    if (!posts.length) {
      this.props.getPosts();
      // console.warn(posts)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { posts, post } = nextProps;
    // console.log(posts)
    if(post.deleteSuccess) {
      openNotificationWithIcon('success', 'Post Deleted!', post.deleteSuccess)
      this.props.getPosts()
      // post.deleteSuccess = null
    }
    if (posts.length > 0) {
      // this.setState({ users })
      this.restructurePosts(posts)
    }
  }

  // gotoUser(id) {
  //   this.props.history.push(`/settings/manageuser/${id}`);
  //   console.log('going...')
  // }

  confirmDelte(postId) {
    console.log(postId)
    this.props.deletePost(postId)
  }

  restructurePosts(posts) {
    let newPosts = []
    posts.forEach(element => {
      newPosts.push(Object.assign(element, {key: element.id}))
    });
    this.setState({
      posts: newPosts
    })
  }

  render() {
    const { posts, columns } = this.state
    return (
      <div className="post-mgt">
        <Row>
          <Table dataSource={posts} columns={columns} />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  posts: state.allPosts.posts,
  post: state.post
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getPosts,
  deletePost
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostManagement)
